import { FC } from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { FullWidthLayout, SectionLayout } from "@/layouts";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { ButtonMui } from "@/components/ui";
import * as Styled from "./support.styles";

interface SupportPartnerProps {
  name: string;
  email: string;
  position: string;
  image: string;
}

export const SupportPartner: FC<SupportPartnerProps> = ({
  name,
  email,
  position,
  image,
}) => {
  const { t } = useTranslation("global");
  return (
    <FullWidthLayout id="signUp" bgColor="var(--surface-95-light)">
      <SectionLayout className="animate__animated animate__fadeIn">
        <Styled.MainSupportContainer>
          <Styled.TitleContainer>
            <h2 className="display-large">
              {t(`support.${position}.title`)}
            </h2>
          </Styled.TitleContainer>
          <Styled.InnerContainer>
            <div>
              <p
                className="body-large"
                style={{ color: "var(--on-background-light)" }}
              >
                {t(`support.${position}.description`)}
              </p>
            </div>
            <Styled.HeroContainer>
              <div>
                <Styled.Img src={image} alt={name} />
              </div>
              <Styled.ContactInfo>
                <em className="body-large weight-medium">{name}</em>
                <p className="body-large">{email}</p>
              </Styled.ContactInfo>
            </Styled.HeroContainer>
            <Styled.BtnContainer>
              {position !== "specialist" ? (
                <ButtonMui
                  variant="contained"
                  color="primary"
                  endIcon={<ArrowForward />}
                  size="medium"
                >
                  <a
                    href="https://calendly.com/cellectenergy/30min"
                    rel="noreferrer noopener"
                    target={"_blank"}
                  >
                    {t("support.expert.btnSchedule")}
                  </a>
                </ButtonMui>
              ) : null}

              {position === "expert" ? (
                <ButtonMui
                  variant="outlined"
                  color="primary"
                  size="medium"
                  endIcon={<ArrowForward />}
                >
                  <Link href="/freetrial">
                    {t("support.expert.btnFreeTrial")}
                  </Link>
                </ButtonMui>
              ) : position === "specialist" ? (
                <Styled.QuestionP className="body-medium">
                  {/* {t("support.specialist.questions")}
                  <span
                    className="body-medium weight-medium"
                    style={{ textDecoration: "underline" }}
                  >
                    {t("support.specialist.contact")}
                  </span> */}
                </Styled.QuestionP>
              ) : null}
            </Styled.BtnContainer>
          </Styled.InnerContainer>
        </Styled.MainSupportContainer>
      </SectionLayout>
    </FullWidthLayout>
  );
};
